import Status from "@/enum/Status";
import { IBranch, ISubscriptor } from "@/services/api/models";

export const findBranch = (branches: IBranch[], id: string): string => {
  const branch = branches.find((branch) => branch.id === id);
  return branch ? branch.title : '-';
};

export const findSubscriptor = (subscriptors: ISubscriptor[], id: string): string => {
  const subscriptor = subscriptors.find((subscriptor) => subscriptor.id === id);
  return subscriptor ? subscriptor.fullname : '-';
};

export const normalizeControlZoneId = (controlZoneId: string | null): string | null => {
  return controlZoneId === 'NULL' ? null : controlZoneId;
};

export const getStatusVariant = (status: Status) => {
  if (status === Status.Aceptada || status === Status.Procesada) return 'success';
  if (status === Status.Preaprobado) return 'warning';
  if (status === Status.Cotizado) return 'info';
  return 'danger';
};

export const getStatusLabel = (statuses: Record<Status, string>, status: Status) => {
  const labels = { ...statuses };
  labels[Status.Procesada] = 'Orden en firme';
  labels[Status.No_Procesada] = 'Declinado';
  return labels[status];
};
